import React from "react"

function SvgComponent({ width = 30, height = 30, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} {...props}>
      <title>{"Facebook"}</title>
      <path
        d="M29.36.467A1.908 1.908 0 0028.09 0H1.93A1.913 1.913 0 00.468.653 1.903 1.903 0 000 1.928v26.168a1.893 1.893 0 00.55 1.357c.356.361.854.547 1.362.547H15.96V18.423h-3.891c0-1.49-.01-2.902.02-4.314.002-.108.29-.295.45-.3.898-.03 1.798-.014 2.698-.017.215-.001.43-.018.723-.03 0-.875-.025-1.709.007-2.54.03-.797.042-1.606.198-2.382.493-2.459 2.265-4.056 4.75-4.282.932-.084 1.878-.032 2.817-.015.517.01 1.032.075 1.68.126v1.246c0 .78.004 1.56.006 2.339 0 .627.031.56-.596.572-.837.016-1.68-.008-2.513.07-.97.092-1.46.596-1.501 1.552-.048 1.076-.011 2.155-.011 3.305.225.014.435.038.645.038 1.1.004 2.2.014 3.299-.003.427-.006.52.169.452.586-.188 1.149-.357 2.301-.449 3.461-.035.45-.197.602-.619.59-.879-.025-1.759-.01-2.638-.006-.216 0-.43.022-.727.038V30h7.348c.455 0 .904-.149 1.249-.447l.015-.013c.41-.361.628-.895.628-1.442V1.92c0-.552-.222-1.09-.64-1.452"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  )
}

export const FacebookIcon = React.memo(SvgComponent)

FacebookIcon.displayName = "FacebookIcon"
